import { useTranslations } from '@vocab/react';
import { Box, IconClear } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import { getVideoThumbnailURL } from '../../utils/getVideoThumbnailURL';

import translations from './.vocab';

import * as styles from './index.css';

interface Props {
  videoUrl: string;
  handleReset: () => void;
  hideRemoveVideoButton?: boolean;
}

export const VideoPreview: FunctionComponent<Props> = ({
  videoUrl,
  handleReset,
  hideRemoveVideoButton = false,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      display="inlineBlock"
      background="body"
      borderRadius="standard"
      className={styles.root}
    >
      {!hideRemoveVideoButton && (
        <Box
          display="block"
          component="button"
          type="button"
          padding="xsmall"
          onClick={handleReset}
          cursor="pointer"
          className={styles.button}
          aria-label={t('video-preview-remove-video-button-aria-label')}
        >
          <IconClear size="xsmall" />
        </Box>
      )}

      <Box
        padding="small"
        paddingTop={hideRemoveVideoButton ? 'small' : 'none'}
      >
        <img
          src={getVideoThumbnailURL(videoUrl)}
          alt={t('video-preview-thumbnail-alt-text')}
          className={styles.image}
          id="YouTubeVideoThumbnail"
        />
      </Box>
    </Box>
  );
};
